import L from 'leaflet';
import "leaflet/dist/leaflet.css";

const defaultMarker = L.icon({
    iconUrl: "https://cdn.portofportland.com/images/marker-icon.png",
    iconRetinaUrl: "https://cdn.portofportland.com/images/marker-icon-2x.png",
    shadowUrl: "https://cdn.portofportland.com/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

function isMobile() {
    return window.matchMedia("(max-width: 767.98px)").matches;
}

function getLayberthsMap(layberths) {
    return new Map(layberths.map(l => [l.name, l]));
}

function createMap(mapSelector, options = {}) {
    const mapEl =
        typeof mapSelector === "string"
            ? document.querySelector(mapSelector)
            : mapSelector;

    if (!mapEl) return null;

    const map = L.map(mapEl, {
        minZoom: options.minZoom ?? 10,
        maxZoom: options.maxZoom ?? 13,
        scrollWheelZoom: options.scrollWheelZoom ?? false
    }).setView(options.center ?? [45.605799, -122.675239], options.zoom ?? 12);

    // Standard Leaflet/OpenStreetMap base layer
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);

    // Add custom tile layer on top, if provided
    if (options.tileUrl) {
        L.tileLayer(options.tileUrl, {
            attribution: options.attribution ?? '© <a href="http://www.portofportland.com">Port of Portland</a>',
            tms: options.tms ?? false,
            opacity: options.opacity ?? 1
        }).addTo(map);
    }

    return map;
}

function initLayberthMap(mapSelector, config) {
    const {
        center = [45.605799, -122.675239],
        zoom = 12,
        minZoom = 10,
        maxZoom = 13,
        showPermanentTooltips = true,
        scrollWheelZoom = false,
        layberths = [],
        tileUrl = null,
    } = config;

    const map = createMap(mapSelector, {
        center,
        zoom,
        minZoom,
        maxZoom,
        scrollWheelZoom,
        tileUrl
    });

    if (!map) return null;

    const layberthMap = getLayberthsMap(layberths);

    const markers = [];

    layberthMap.forEach(layberth => {
        const marker = L.marker(layberth.coordinates, { icon: defaultMarker });

        marker.bindTooltip("<a href='#" + layberth.target + "'>" + layberth.name + "</a>", {
            interactive: true,
            permanent: true,
            direction: "right",
            offset: [20, -20]
        });

        markers.push(marker);
    });

    const layer = L.layerGroup(markers);

    layer.addTo(map);

    



    return map;
}

window.PortJS = window.PortJS || {};
window.PortJS.initLayberthMap = initLayberthMap;

export { initLayberthMap };